import React, { useState } from 'react';
import { ScissorsIcon, XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-black border-t border-delux-gold/30 pt-16 pb-8 px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="max-w-4xl mx-auto text-center" data-id="element-64">
          <div className="flex justify-center mb-8" data-id="element-65">
            <img src="https://cdn.magicpatterns.com/uploads/qVVJXV3u6YvRBr3F6qx2T7/logodeluxbarber.png" alt="Barbershop Delux Cut Logo" className="h-20 object-contain" data-id="element-66" />
          </div>

          <h3 className="font-heading text-2xl text-delux-gold mb-6 italic" data-id="element-67">
            Donde el Estilo Cobra Vida
          </h3>

          <div className="font-body text-delux-body space-y-2 mb-10" data-id="element-68">
            <p data-id="element-69">Sunshine Plaza | 1145 Homestead Rd N, Lehigh Acres, FL 33936</p>
            <p data-id="element-70">
              <a href="tel:7866516944" className="hover:text-delux-gold transition-colors" data-id="element-71">
                (786) 651-6944
              </a>
            </p>
            <p data-id="element-72">Abiertos hasta las 7 PM</p>
          </div>

          <div className="flex items-center justify-center mb-8 opacity-50" data-id="element-73">
            <div className="h-px bg-delux-gold w-12" data-id="element-74"></div>
            <ScissorsIcon className="w-4 h-4 text-delux-gold mx-4" data-id="element-75" />
            <div className="h-px bg-delux-gold w-12" data-id="element-76"></div>
          </div>

          {/* Privacy & Terms Links */}
          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-77">
            <button onClick={() => setActiveModal('privacy')} className="font-body text-sm text-delux-body/60 hover:text-delux-gold transition-colors underline underline-offset-4 decoration-delux-gold/30" data-id="element-78">
              Política de Privacidad
            </button>
            <span className="text-delux-body/30" data-id="element-79">|</span>
            <button onClick={() => setActiveModal('terms')} className="font-body text-sm text-delux-body/60 hover:text-delux-gold transition-colors underline underline-offset-4 decoration-delux-gold/30" data-id="element-80">
              Términos y Condiciones
            </button>
          </div>

          <p className="font-body text-sm text-delux-body/50" data-id="element-81">
            &copy; {new Date().getFullYear()} Barbershop Delux Cut. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {/* Modal Popups */}
      <AnimatePresence data-id="element-82">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-83">
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-delux-card border border-delux-gold/30 rounded-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-84">
              {/* Modal Header */}
              <div className="sticky top-0 bg-delux-card border-b border-delux-gold/20 px-6 py-4 flex items-center justify-between rounded-t-xl" data-id="element-85">
                <h3 className="font-heading text-xl text-delux-gold" data-id="element-86">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-delux-body/60 hover:text-delux-gold transition-colors p-1" aria-label="Cerrar" data-id="element-87">
                  <XIcon className="w-6 h-6" data-id="element-88" />
                </button>
              </div>

              {/* Modal Content */}
              <div className="px-6 py-6 font-body text-delux-body/80 text-sm leading-relaxed space-y-4" data-id="element-89">
                {activeModal === 'privacy' ? <>
                    <p className="text-delux-white font-medium text-base" data-id="element-90">
                      Última actualización: Marzo 2026
                    </p>
                    <p data-id="element-91">
                      En Barbershop Delux Cut, respetamos tu privacidad y nos
                      comprometemos a proteger tu información personal. Esta
                      política describe cómo recopilamos, usamos y protegemos
                      tus datos.
                    </p>
                    <h4 className="font-heading text-delux-gold text-lg pt-2" data-id="element-92">
                      Información que Recopilamos
                    </h4>
                    <p data-id="element-93">
                      Podemos recopilar la siguiente información cuando nos
                      contactas o visitas nuestro establecimiento:
                    </p>
                    <ul className="list-disc list-inside space-y-1 pl-2" data-id="element-94">
                      <li data-id="element-95">
                        Nombre y datos de contacto (teléfono, correo
                        electrónico)
                      </li>
                      <li data-id="element-96">Preferencias de servicio y historial de citas</li>
                      <li data-id="element-97">
                        Información proporcionada voluntariamente durante la
                        consulta
                      </li>
                    </ul>
                    <h4 className="font-heading text-delux-gold text-lg pt-2" data-id="element-98">
                      Uso de la Información
                    </h4>
                    <p data-id="element-99">Utilizamos tu información exclusivamente para:</p>
                    <ul className="list-disc list-inside space-y-1 pl-2" data-id="element-100">
                      <li data-id="element-101">Programar y gestionar tus citas</li>
                      <li data-id="element-102">Personalizar tu experiencia de servicio</li>
                      <li data-id="element-103">
                        Comunicarnos contigo sobre tu cita o promociones (con tu
                        consentimiento)
                      </li>
                    </ul>
                    <h4 className="font-heading text-delux-gold text-lg pt-2" data-id="element-104">
                      Protección de Datos
                    </h4>
                    <p data-id="element-105">
                      No vendemos, intercambiamos ni transferimos tu información
                      personal a terceros. Implementamos medidas de seguridad
                      para proteger tu información.
                    </p>
                    <h4 className="font-heading text-delux-gold text-lg pt-2" data-id="element-106">
                      Contacto
                    </h4>
                    <p data-id="element-107">
                      Si tienes preguntas sobre esta política, contáctanos al
                      (786) 651-6944 o visítanos en Sunshine Plaza, 1145
                      Homestead Rd N, Lehigh Acres, FL 33936.
                    </p>
                  </> : <>
                    <p className="text-delux-white font-medium text-base" data-id="element-108">
                      Última actualización: Marzo 2026
                    </p>
                    <p data-id="element-109">
                      Al utilizar los servicios de Barbershop Delux Cut, aceptas
                      los siguientes términos y condiciones.
                    </p>
                    <h4 className="font-heading text-delux-gold text-lg pt-2" data-id="element-110">
                      Servicios
                    </h4>
                    <p data-id="element-111">
                      Ofrecemos servicios de barbería profesional incluyendo
                      cortes de cabello, afeitados, diseños de barba y
                      tratamientos capilares. Todos los servicios están sujetos
                      a disponibilidad.
                    </p>
                    <h4 className="font-heading text-delux-gold text-lg pt-2" data-id="element-112">
                      Citas y Cancelaciones
                    </h4>
                    <ul className="list-disc list-inside space-y-1 pl-2" data-id="element-113">
                      <li data-id="element-114">
                        Se aceptan clientes sin cita previa, sujeto a
                        disponibilidad
                      </li>
                      <li data-id="element-115">
                        Se recomienda reservar con anticipación para garantizar
                        tu horario
                      </li>
                      <li data-id="element-116">
                        Agradecemos notificación previa si necesitas cancelar o
                        reprogramar
                      </li>
                    </ul>
                    <h4 className="font-heading text-delux-gold text-lg pt-2" data-id="element-117">
                      Garantía de Satisfacción
                    </h4>
                    <p data-id="element-118">
                      Si no estás satisfecho con tu corte, dínoslo y lo
                      corregiremos. Esta es nuestra promesa Delux Cut. La
                      corrección debe solicitarse dentro de los 7 días
                      posteriores al servicio.
                    </p>
                    <h4 className="font-heading text-delux-gold text-lg pt-2" data-id="element-119">
                      Pagos
                    </h4>
                    <p data-id="element-120">
                      Aceptamos efectivo y las principales tarjetas de
                      crédito/débito. Los precios están sujetos a cambios sin
                      previo aviso.
                    </p>
                    <h4 className="font-heading text-delux-gold text-lg pt-2" data-id="element-121">
                      Responsabilidad
                    </h4>
                    <p data-id="element-122">
                      Barbershop Delux Cut no se hace responsable por reacciones
                      alérgicas a productos. Infórmanos sobre cualquier alergia
                      o condición antes del servicio.
                    </p>
                    <h4 className="font-heading text-delux-gold text-lg pt-2" data-id="element-123">
                      Contacto
                    </h4>
                    <p data-id="element-124">
                      Para cualquier consulta sobre estos términos, contáctanos
                      al (786) 651-6944.
                    </p>
                  </>}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}